import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';
import RelaunchEnforcementLinkObject from 'redpoints-model-js/model/system/RelaunchEnforcementLinkObject';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import LinkEnforcementController from 'redpoints-restapi-connector/controller/LinkEnforcementController';

import {
  getApiResponseFromStatusValue,
  getProcessedEntities,
  getResponse,
  OPERATIONS,
} from 'redpoints-front-common/services';

export default class LinkManagementService {
  static async relaunchEnforcement(context, detectionLinks, contentLinks) {
    const detectionLinksToProcess = cleanLinks(detectionLinks);
    const contentLinksToProcess = cleanLinks(contentLinks);

    if (!shouldProcess(detectionLinksToProcess, contentLinksToProcess)) {
      return getApiResponseFromStatusValue(HttpStatus.OK, null);
    }

    const relaunchEnforcementLinkObjects = getRelaunchEnforcementLinkObjects(
      detectionLinksToProcess,
      contentLinksToProcess
    );

    const entitiesToProcess = getEntitiesToProcess(
      context,
      relaunchEnforcementLinkObjects
    );

    const promises = getPromises(entitiesToProcess);

    const resolvedPromises = await Promise.allSettled(promises);

    const processedEntities = getProcessedEntities(
      entitiesToProcess,
      resolvedPromises
    );

    return getResponse(processedEntities);
  }
}

const cleanLinks = links =>
  Array.isArray(links) ? removeDuplicates(links) : [];

const removeDuplicates = items => [...new Set(items)];

const shouldProcess = (detectionLinks, contentLinks) =>
  Boolean(detectionLinks.length + contentLinks.length);

const getRelaunchEnforcementLinkObjects = (detectionLinks, contentLinks) => {
  const detectionLinkObjects = detectionLinks.map(detectionLink => {
    const relaunchEnforcement = new RelaunchEnforcementLinkObject();
    relaunchEnforcement.linkType = LinkTypeEnum.DETECTION;
    relaunchEnforcement.url = detectionLink;
    return relaunchEnforcement;
  });

  const contentLinkObjects = contentLinks.map(contentLink => {
    const relaunchEnforcement = new RelaunchEnforcementLinkObject();
    relaunchEnforcement.linkType = LinkTypeEnum.CONTENT;
    relaunchEnforcement.url = contentLink;
    return relaunchEnforcement;
  });

  return [...detectionLinkObjects, ...contentLinkObjects];
};

const getEntitiesToProcess = (context, relaunchEnforcementLinkObjects) =>
  relaunchEnforcementLinkObjects.map(relaunchEnforcementLinkObject =>
    getKeyPromiseStructure(context, relaunchEnforcementLinkObject)
  );

const getKeyPromiseStructure = (context, relaunchEnforcementLinkObject) => ({
  key: `${relaunchEnforcementLinkObject.linkType.name}_${relaunchEnforcementLinkObject.url}`,
  operation: OPERATIONS.RELAUNCH_ENFORCEMENT,
  value: LinkEnforcementController.relaunchEnforcement(
    context,
    relaunchEnforcementLinkObject
  ),
});

const getPromises = entitiesToProcess =>
  entitiesToProcess.map(entityToProcess => entityToProcess.value);
